// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import Switch from 'react-switch';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types

type SwitcherProps = {
  onChange: (checked: boolean) => void;
  checked: boolean;
  id: string;
  style?: React.CSSProperties;
  onColor?: string;
  disabled?: boolean;
};

export default ({
  onChange,
  checked,
  id,
  style,
  onColor,
  disabled,
}: SwitcherProps) => (
  <div style={style}>
    <Switch
      onChange={onChange}
      checked={checked}
      onColor={onColor || '#56c568'}
      width={44}
      height={24}
      id={id}
      handleDiameter={20}
      checkedIcon={false}
      uncheckedIcon={false}
      disabled={disabled}
    />
  </div>
);
